import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthService from '../services/AuthService';
import logo from '../assets/images/logo.png'; 
import ApiService from "../services/ApiService";
import { toast } from 'react-toastify';
import { formatTimeAgo } from '../utils/helper';
import Image from './Image';


const Header = ({ notifications, unreadCount, getNotifications, setNotifications, settings }) => {
    const navigate = useNavigate();
    const [user] = useState(JSON.parse(localStorage.getItem('user')));
    
    const companyLogo = settings?.company_logo || logo;


    const logout = () => {
        if (window.confirm('Are you sure? you want to logout.')) {
            AuthService.logout();
        }
    };


    // useEffect(() => {
    //     if (search.trim().length >= 2) {
    //         const timeoutId = setTimeout(() => {
    //             globalSearch();
    //         }, 300); // Debounce search by 300ms
            
    //         return () => clearTimeout(timeoutId);
    //     } else {
    //         setSearchResults({boats:[], bookings:[], users:[]});
    //     }
    // }, [search, globalSearch]); 

    
    const clearAllNotifications = async () => {
        try {
            const isCustomer = user && user.role === 'customer';
            const url = isCustomer ? "customer/notifications/clear-all" : "admin/notifications/clear-all";
            const response = await ApiService.request({
                method: "POST",
                url: url,
            });
            const data = response.data;
            if (data.status) {
                setNotifications([]);
                toast.success(data.message || 'All notifications cleared');
                getNotifications();
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            console.log(error);
        }
    };

 

    return (
        <div id="kt_app_header" className="app-header bg-gradient-right">
            <div className="app-container container-fluid d-flex align-items-stretch justify-content-between" id="kt_app_header_container">
                <div className="d-flex align-items-center d-lg-none ms-n2 me-2" title="Show sidebar menu">
                    <div className="btn btn-icon btn-active-color-primary w-35px h-35px" id="kt_app_sidebar_mobile_toggle">
                        {/* SVG Icon here */}
                        <i className="fas fa-bars fs-2 text-white"></i>
                    </div>
                </div>
                <div className="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
                    <Link to="/admin/dashboard" className="d-lg-none rounded">
                        <Image alt="Logo" src={companyLogo} className="h-50px" style={{ maxHeight: '300px' }} />
                    </Link>
                </div>

                <div className="d-flex align-items-stretch justify-content-between flex-lg-grow-1" id="kt_app_header_wrapper">
                    <div className="app-header-menu app-header-mobile-drawer align-items-stretch">
                        <div className="menu menu-rounded menu-column menu-lg-row my-5 my-lg-0 align-items-stretch fw-semibold px-2 px-lg-0" id="kt_app_header_menu" data-kt-menu="true">
                            {/* Add Menu Items */}
                        </div>
                    </div>
                    <div className="app-navbar flex-shrink-0">
                    <div className="app-navbar-item ms-1 ms-lg-3">
                        </div>

                        <div className="app-navbar-item ms-1 ms-lg-3">
                            <div 
                                className="btn btn-icon btn-custom btn-active-primary btn-active-color-primary w-35px h-35px w-md-40px h-md-40px position-relative notification-dropdown cursor-pointer"
                                onClick={() => navigate('/notifications')}
                                style={{ cursor: 'pointer' }}
                                title="View Notifications"
                            >
                                <i className='fas fa-bell text-gray-100 fs-2'></i>
                                {unreadCount > 0 && (
                                    <span className="bullet bullet-dot h-20px w-20px position-absolute translate-middle top-5 start-75 bg-danger text-white"> 
                                       <small>{unreadCount}</small> 
                                    </span>
                                )}
                            </div>
                            <div className="menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px notification-submenu" style={{ zIndex: 107, position: 'fixed', inset: '0 auto auto auto', margin: 0, top:'55px', right:'10px' }}>
                                <div className="d-flex flex-column mt-5 px-2">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h4 className="text-dark fw-bold mb-0">Notifications</h4>
                                        <Link to="/notifications" className="btn btn-sm btn-base">
                                            View All
                                        </Link>
                                    </div>
                                    <hr className="p-0 m-0" />
                                    <div className="table" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                        <table className="table fs-6">
                                            <tbody>
                                            { notifications.length > 0 ? (
                                                notifications.map((not, index) => (
                                                <tr  className='border border-bottom bg-light' key={index}>
                                                    <td > 
                                                         <span  className="text-dark fs-5" >{not.title}</span> <br />
                                                         <span  className="text-dark" >{not.message}</span> 
                                                    </td>
                                                    <td width={'40px'} className='p-0'> 
                                                        <small >{formatTimeAgo(not.created_at || not.createdAt)}</small>
                                                    </td>
                                                </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="2" className="text-center py-5">
                                                        <h6 className="text-muted">No notifications</h6>
                                                    </td>
                                                </tr>
                                            )}
                                            </tbody>
                                        </table>
                                    </div>
                                    {notifications.length > 0 && (
                                        <div className="text-center mt-3 mb-3">
                                            <Link to="/notifications" className="btn btn-sm btn-base me-2">
                                                View All Notifications
                                            </Link>
                                            <button className="btn btn-sm btn-light" onClick={clearAllNotifications}>
                                                Clear All
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="app-navbar-item ms-1 ms-lg-3" id="kt_header_user_menu_toggle">
                            <div className="cursor-pointer symbol symbol-35px symbol-md-40px profile-dropdown">
                                <Image src={user?.picture} alt="user" />
                            </div>
                            <div className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px profile-submenu"
                             style={{ zIndex: 107, position: 'fixed', inset: '0 auto auto auto', margin: 0,top:'55px', right:'10px' }}>
                                <div className="menu-item px-3">
                                    <div className="menu-content d-flex align-items-center px-3">
                                        <div className="symbol symbol-50px me-5">
                                            <Image alt="Logo" src={user?.picture} />
                                        </div>
                                        <div className="d-flex flex-column">
                                            <div className="fw-bold d-flex align-items-center fs-5"> {user.name} </div>
                                            <Link to="#" className="fw-semibold text-muted text-hover-primary fs-7"> {user.email} </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="separator my-2"></div>
                                <div className="menu-item px-5 my-1">
                                    <Link to="/account" className="menu-link px-5"> {('Account Settings')}</Link>
                                </div>
                                <div className="menu-item px-5">
                                    <button  onClick={logout} className="menu-link px-5 btn btn-transparent">{('Logout')}</button>
                                </div>
                            </div>
                        </div>
                        <div className="app-navbar-item d-none ms-2 me-n3" title="Show header menu">
                            <div className="btn btn-icon btn-active-color-primary w-35px h-35px" id="kt_app_header_menu_toggle">
                                {/* SVG Icon */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;
